export const SET_USER_INFO = "SET_USER_INFO";

export const setUserInfo = (userInfo) => ({
  type: SET_USER_INFO,
  payload: userInfo,
});
